import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser, selectIsSubClient } from "../store/userSlice";
import { selectSubClientMode } from "../store/authPreferencesSlice";
import { useNavUtils } from "../utils/navUtils";
import { stytchService } from "../utils/stytchService";

export default function RequireUser() {
  const reduxUser = useSelector(selectUser);
  const isSubClient = useSelector(selectIsSubClient);
  const subClientMode = useSelector(selectSubClientMode);
  const location = useLocation();
  const { getLoginTarget, getNav } = useNavUtils();
  
    // In sub-client mode, check if we have the RIGHT user
  if (subClientMode) {
    if (reduxUser && !isSubClient) {
      // We have a user but it's the parent, not the sub-client
      // Redirect to login to authenticate the sub-client
      const destination = getNav(getLoginTarget(), { includeParams: true });
      console.log("[RequireUser] 👎; in subClientMode but user is parent, re-routing to", destination);
      return <Navigate to={destination} state={{ from: location }} replace />;
    }
  }

  // Allow access if Redux user exists
  if (reduxUser) {
    console.log("[RequireUser] 👍; has user in Redux, allowing Outlet", reduxUser);
    return <Outlet />;
  }

  // Check Stytch session synchronously on every render
  const hasStytchSession = stytchService.hasStytchSessionSync();

  // Allow access if Stytch session exists
  if (hasStytchSession) {
    console.log("[RequireUser] 👍; has valid Stytch session, allowing Outlet");
    return <Outlet />;
  }

  // Redirect to login if neither Redux user nor Stytch auth exists
  const destination = getNav(getLoginTarget(), { includeParams: true });
  console.log("[RequireUser] 👎; no user in Redux or Stytch, re-routing to", destination);
  return <Navigate to={destination} state={{ from: location }} replace />;
}
